import { AIRCON_HUB_ALTERNATES } from '../../../../../components/market/AirconCityHub'

// Dubai AC service hub.
const content = {
    title: (c) => `AC Service Dubai from ${c.money(c.tables.general[0].wall)} | Cleaning, Gas & Repair`,
    description: (c) =>
        `AC service in Dubai for split and ducted units: cleaning from ${c.money(c.tables.general[0].wall)}, coil wash from ${c.money(c.tables.chemicalWash[0].wall)}, gas refill, repair and AMC. Upfront prices.`,
    eyebrow: 'Dubai',
    h1: 'AC Service in Dubai',
    lead: (c) =>
        `Cleaning, coil washing, gas refills and repairs for apartments, villas and townhouses across Dubai. Every price is on this page before you book - AC cleaning starts at ${c.money(c.tables.general[0].wall)} for one split unit, and each extra unit costs less.`,
    image: 'blog/living/repairman-doing-air-conditioner-service.jpg',
    imageAlt: 'Technician servicing an AC unit in a Dubai home',
    facts: ['Split, ducted and cassette units', 'Upfront prices in AED', 'Weekend slots'],
    defaultMount: 'Ducted',
    priceTitle: 'Prices for AC service in Dubai',
    priceIntro: 'Choose the service, your unit type and the number of units. Concealed ducted units are the usual type in Dubai apartments; wall-mounted splits are common in older buildings and villa bedrooms.',
    servicesTitle: 'Every AC service we offer in Dubai',
    servicesIntro: 'Each page explains what the job involves, how long it takes and what it costs for your unit type.',
    sections: [
        {
            title: 'Running an AC in Dubai is different',
            cards: [
                { title: 'Ten months of hard work', body: 'Units here run almost continuously from May to October and much of the rest of the year. Parts wear faster and coils collect dirt faster than in milder climates.' },
                { title: 'Dust is the main enemy', body: 'Shamal winds and dust storms push fine sand through every gap. It clogs filters within weeks and bakes onto wet coils, cutting airflow and feeding mould.' },
                { title: 'Ducted units hide problems', body: 'Concealed ducted units sit above the false ceiling, so leaks and dirt go unnoticed until water drips from a grille or the room stops cooling.' },
                { title: 'District cooling vs own AC', body: 'Many towers run on district cooling, where your unit is a chilled-water fan coil with no refrigerant. It still needs cleaning, but gas refills do not apply.' },
                { title: 'Tenancy rules matter', body: 'Who pays for AC upkeep depends on your tenancy contract. Routine cleaning is usually the tenant\'s job; major repairs usually fall on the landlord.' },
                { title: 'Bills follow the coil', body: 'A dirty coil makes the compressor run longer for the same comfort. In summer that shows up directly on your DEWA bill.' },
            ],
        },
        {
            title: 'A sensible service schedule for Dubai',
            tone: 'muted',
            paragraphs: [
                'Clean or replace filters every month in summer and after every dust storm. Book an AC cleaning every three to four months, and a coil chemical wash once a year - ideally in March or April, before the heat. Check the gas pressure only if the unit stops cooling properly; a sealed system that is not leaking does not need regular top-ups.',
                'If you want this done without having to remember it, a yearly maintenance contract (AMC) bundles three or four visits at a fixed price.',
            ],
        },
    ],
    areasIntro: 'We cover all of Dubai. These are the communities we get the most requests from - each page has notes on the buildings and AC types common in that area.',
    faqs: [
        {
            question: 'How much does AC service cost in Dubai?',
            answer: (c) => `AC cleaning costs ${c.money(c.tables.general[0].wall)} for one split unit and ${c.money(c.tables.general[0].ducted)} for one concealed ducted unit. A coil chemical wash starts at ${c.money(c.tables.chemicalWash[0].wall)}. Prices per unit fall as you add units: three split units cost ${c.money(c.tables.general[2].wall)} for a cleaning.`,
        },
        {
            question: 'How often should I service my AC in Dubai?',
            answer: 'Every three to four months for a routine cleaning, with a coil chemical wash once a year. Clean the filters monthly in summer and after dust storms.',
        },
        {
            question: 'Do you service concealed ducted AC units?',
            answer: 'Yes. Ducted units are the most common type in Dubai apartments. The technician works through the ceiling access panel to clean the filter, coil, blower and drain tray.',
        },
        {
            question: 'Can you refill gas in a district-cooled apartment?',
            answer: 'No - a district-cooled apartment has a chilled-water fan coil, not a refrigerant circuit, so there is no gas to refill. If it is not cooling, the cause is usually a dirty coil or filter, a stuck valve or a building supply issue.',
        },
        {
            question: 'Do you work on weekends?',
            answer: 'Yes. Saturday and Sunday slots are available; they fill first in summer, so book a few days ahead.',
        },
    ],
    serviceType: 'Air conditioner servicing',
    offers: (c) => [
        { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
        { name: 'AC cleaning, 1 ducted unit', price: c.tables.general[0].ducted },
        { name: 'AC cleaning, 3 split units', price: c.tables.general[2].wall },
        { name: 'Coil chemical wash, 1 split unit', price: c.tables.chemicalWash[0].wall },
        { name: 'Coil chemical wash, 1 ducted unit', price: c.tables.chemicalWash[0].ducted },
        { name: 'Deep cleaning (full dismantle), 1 split unit', price: c.tables.chemicalOverhaul[0].wall },
        { name: 'Gas refill top-up (R410A), 1 outdoor unit', price: c.tables.gas.R410A.half },
        { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
    ],
    alternates: AIRCON_HUB_ALTERNATES,
}

export default content
